"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _mapBox = _interopRequireDefault(require("@/components/map/mapBox"));
var _merchant = require("@/api/merchant");
var _status = require("@/api/iot/status");
var _branchBack = require("@/api/iot/branchBack");
var _merchantSelect = _interopRequireDefault(require("@/components/merchant/merchantSelect.vue"));
var _default = {
  props: ['editItem', 'roleList'],
  components: {
    mapBox: _mapBox.default,
    MerchantSelector: _merchantSelect.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      map: {
        longitudelatitude: ''
      },
      form: {
        id: '',
        merchant_id: '',
        name: '',
        // company_name: '',
        serve_mobile: '',
        // examine_status: '',
        address: '',
        longitude: '',
        latitude: '',
        status: 0,
        // service_time: '',
        // end_time: '',
        // branch_type: '',
        remark: ''
        // electricity_price: '',
        // is_discount: '',
      },

      merchantList: [],
      branchStatusList: [],
      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入网点名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入网点地址',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '网点';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            // this.form = this.editItem
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
            _this.map.longitudelatitude = _this.form.longitude + ',' + _this.form.latitude;
          }
        });
      } else {
        this.map = this.$options.data().map;
        this.form = this.$options.data().form;
        this.$refs['form'].resetFields();
      }
    }
  },
  mounted: function mounted() {
    this.getBranchStatusList();
    this.getMerchantList();
  },
  methods: {
    handleMerchantIdUpdate: function handleMerchantIdUpdate(merchantId) {
      this.form.merchant_id = merchantId;
      console.log('this.searchForm', this.searchForm);
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _branchBack.branchSave)(_this2.form).then(function (res) {
            _this2.dialogVisible = false;
            _this2.$emit('getList');
          });
        } else {
          _this2.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    },
    getBranchStatusList: function getBranchStatusList() {
      var _this3 = this;
      (0, _status.getBranchStatusList)().then(function (res) {
        console.log('getBranchStatusList', res);
        if (res) {
          _this3.branchStatusList = res || [];
        }
      });
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    sendPointInfo: function sendPointInfo(info) {
      // console.log('sendPointInfo', info)
      this.form.address = info.address;
      this.form.longitude = info.point.lng;
      this.form.latitude = info.point.lat;
      this.map.longitudelatitude = info.point.lng + ',' + info.point.lat;
    }
  }
};
exports.default = _default;